import { useEffect, useState } from 'react'
import { breakpoints } from 'globalStyles'

const useDetectDesktop = () => {
  // Desktop: width >= lg
  const [mQuery, setMQuery] = useState({
    matches: globalThis.matchMedia(breakpoints.desktop).matches,
  })

  useEffect(() => {
    const mediaQueryList = globalThis.matchMedia(breakpoints.desktop)
    const handler = (e) => setMQuery(e)
    mediaQueryList.addEventListener('change', handler)
    return () => mediaQueryList.removeEventListener('change', handler)
  }, [])

  return mQuery.matches
}

export default useDetectDesktop
